"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ICurrentOrPast = void 0;
var ICurrentOrPast;
(function (ICurrentOrPast) {
    ICurrentOrPast["Current"] = "current";
    ICurrentOrPast["Past"] = "past";
})(ICurrentOrPast || (exports.ICurrentOrPast = ICurrentOrPast = {}));
//# sourceMappingURL=current-or-past.js.map